<template>
    <pocket-block class="chat-main" :class="{'is-full': mode == 'full', 'chat-main_fixed': showChat }" @close="$emit('close')" ref="chat-main">
        <icon v-if="showIndicator" @click.native="showChats"></icon>

        <transition name="fade">
            <overlay :is-shown="loading">
                <bounce-spinner/>
            </overlay>
        </transition>

        <chats class="chat-main__list" v-on:close="closeChats"
            v-show="showChatList && !showCloseBtn"
            @selectRoom="selectRoom"
            @selectAvailable="selectAvailable"
            @showCreateChat="selectCreateChat"
            :loading="loading"
        />

        <!-- <transition name="fade"> -->
            <div class="chat-main__side" v-if="showCloseBtn" ref="main-side">

                <chat v-if="showChat"
                    @cancel="cancelCreateChat"
                />

                <create-chat v-if="showCreateChat"
                            @back="cancelCreateChat"
                            @selectRoom="selectRoom"
                />

                <available v-show="showAvailable"
                        @selectRoom="selectRoom"
                        @cancel="cancelCreateChat"/>
            </div>
        <!-- </transition> -->
    </pocket-block>

</template>

<script>
    import Icon from "./Icon.vue";
    import Vue from "vue";
    import Chats from "./chat-list/Chats.vue";
    import {SocketHelper} from "../helpers/SocketHelper";
    import Chat from "./chat/Chat";
    import ViewTypes from "../enums/ViewTypes";
    import Available from "./chat-list/Available";
    import CreateChat from "./create-chat/CreateChat";
    import {handlePermissions} from "../notifications/Permissions";
    import {EventBus} from "@common/EventBus";
    import CloseBtn from "../../common/CloseBtn.vue";
    import {detectMob} from "../../../common/mobileHelper";
    import {resetScroll} from "../../../service/helpers/scrollHelper";
    import PocketBlock from "../../common/pocket/Pocket.vue";

    import BounceSpinner from "@share/common/BounceSpinner.vue";
    import Overlay from "@share/common/Overlay.vue";

    export default Vue.extend({
        name: "ChatComponent",
        components: {
            Icon, Chats, Chat, Available, CreateChat, CloseBtn, PocketBlock, BounceSpinner, Overlay
        },
        props: {
            client: {
                required: true
            },
            session: {
                type: Object,
                required: true
            },
            isShowing: {
                type: Boolean,
                default: false
            },
            mode: {
                type: String,
                default: 'icon'
            }
        },
        data() {
            return {
                previousScreen: null,
                interval: null,
                scrollTops: {},
                localRouteHash: "",
                loading: false,
                roomsLoaded: false,
                selectors: {
                    chatsList: '.chats-chat-box',
                    available: '.available-chat-box'
                }
            }
        },
        computed: {
            showIndicator() {
                return this.$store.state.chat.view == ViewTypes.indicator;
            },
            showChatList() {
                return this.$store.state.chat.view == ViewTypes.chatsList || this.mode == 'full';
            },
            showChat() {
                return this.$store.state.chat.view == ViewTypes.chat;
            },
            showAvailable() {
                return this.$store.state.chat.view == ViewTypes.available;
            },
            showCreateChat() {
                return this.$store.state.chat.view == ViewTypes.createChat;
            },
            showCloseBtn() {
                return this.showChat || this.showCreateChat || this.showAvailable;
            },
            routeHash() {
                return this.$route.hash;
            }
        },
        watch: {
            async isShowing() {
                //fetching data when chat window will open and never after
                if(this.isShowing && !this.roomsLoaded) {
                    try {
                        this.loading = true;
                        await this.$store.dispatch('chat/groups/fetchData');

                        if (this.routeHash.startsWith('#chat_')) {
                            const id = this.routeHash.substring(6);
                            this.setScreenAsChat(id);
                        }

                        this.roomsLoaded = true;

                    }
                    catch (e) {
                        //@todo chat notification
                        this.$store.dispatch('reportException', e, {root: true});
                    }
                    finally {
                        this.loading = false;
                    }
                }
            },
            routeHash() {
                if (this.routeHash == '#' || !this.routeHash || this.routeHash === '#chat') {
                    this.changeScreen(ViewTypes.chatsList);
                    this.$store.dispatch('chat/room/resetRoom');
                } else {
                    if (this.routeHash.startsWith('#chat_')) {
                        const id = this.routeHash.substring(6);
                        this.setScreenAsChat(id);
                    }
                    else if(this.routeHash.startsWith('#settings') || this.routeHash.startsWith('#notifications')) {
                        return;
                    }
                    else {
                        this.changeScreen(this.routeHash.substring(1));
                    }
                }
            }
        },
        methods: {
            setScreenAsChat(id) {
                let room = this.$store.state.chat.rooms.list.find(item => {
                        return item.id == id;
                    });
                if (!room) {
                    room = [...this.$store.state.chat.groups.groups, ...this.$store.state.chat.groups.channels].find(item => {
                        return item.id == id;
                    });
                }
                if (room) {
                    this.$store.dispatch('chat/room/setRoom', room);
                    this.changeScreen(ViewTypes.chat);
                }
            },
            setScrollTop() {
                const selector = this.selectors[this.$store.state.chat.view];
                if (selector) {
                    const element = document.querySelector(selector);
                    if (element) {
                        this.scrollTops[this.$store.state.chat.view] = element.scrollTop;
                    }
                }
            },
            changeScreen(screenType) {
                if (screenType == ViewTypes.available) {
                    this.previousScreen = ViewTypes.chatsList
                }
                else {
                    this.previousScreen = this.$store.state.chat.view == ViewTypes.createChat ?
                        ViewTypes.chatsList :
                        this.$store.state.chat.view;
                }
                this.setScrollTop();

                this.$store.dispatch('chat/setView', screenType);

                //ALERT: проверить нужны ли манипуляции со скролом
                if (this.scrollTops[screenType]) {
                    this.$nextTick(() => {
                        const selector = this.selectors[screenType];
                        if (selector) {
                            const element = document.querySelector(selector);
                            if (element) {
                                element.scrollTop = this.scrollTops[this.$store.state.chat.view];
                                delete this.scrollTops[this.$store.state.chat.view];
                            }
                        }
                    })
                }

                if(screenType === ViewTypes.chat) {
                    document.body.classList.add("no-scroll")
                }
                else {
                    document.body.classList.remove("no-scroll")
                }

                this.$nextTick(() => {
                    this.resizeHandler();
                });
            },
            selectAvailable() {
                window.location.hash = ViewTypes.available;
            },
            closeChats() {
                this.changeScreen(ViewTypes.indicator);
            },
            selectRoom(room) {
                if(this.$route.hash?.startsWith('#chat_')) {
                     window.location.hash = "#chat";
                }
                this.$nextTick(() => {
                    this.$router.push({
                        name: this.$route.name,
                        hash: '#chat_' + room.id,
                        params: {
                            ...this.$route.params
                        }
                    })
                })
            },
            selectCreateChat() {
                window.location.hash = ViewTypes.createChat;
            },
            backToChats() {
                this.changeScreen(this.previousScreen);
                this.$store.dispatch('chat/room/resetRoom');
            },
            cancelCreateChat() {
                // TODO - сменить название метода
                this.$store.dispatch('chat/room/resetRoom');
                if(this.previousScreen === ViewTypes.available) {
                    this.changeScreen(this.previousScreen);
                    return
                }

                window.location.hash = "#chat";
            },
            async init() {
                this.$store.dispatch('chat/setSession', this.session);
                const socket = new SocketHelper(this.$store);
                socket.connect(this.$store.state.session);
                this.$store.commit('chat/setSocket', socket);

                try {
                    await this.$store.dispatch('chat/rooms/fetchRooms');
                    if (this.routeHash.startsWith('#chat_')) {
                        const id = this.routeHash.substring(6);
                        this.setScreenAsChat(id);
                    }
                }
                catch(e) {
                    this.$store.dispatch('reportException', e, {root: true});
                }

                this.interval = setInterval(() => {
                    this.$store.dispatch('chat/rooms/fetchRooms')
                    .catch(e => {
                        //@todo chat notification
                        this.$store.dispatch('reportException', e, {root: true});
                    })
                }, 900000) //15 minutes

                handlePermissions();
            },
            async messageToComplete(userId) {
                let room = this.$store.state.chat.rooms.list.find(item => item.userId == userId && item.type == 'direct')
                if (room) {
                    this.selectRoom(room);
                }
                else {
                    try {
                        await this.$store.dispatch('chat/profiles/fetchProfile', userId);
                        let user = this.$store.state.chat.profiles.list[userId] || null;
                        if (user) {
                            room = await this.$store.dispatch('chat/rooms/createDirectRoom', user);
                            room && this.selectRoom(room);
                        }
                        else {
                            this.$store.dispatch('reportError', 'Пользователь не найден', {root: true});
                        }
                    }
                    catch (e) {
                        this.$store.dispatch('reportException', e, {root: true});
                    }
                }
            },
            async messageTo(userId) {
                resetScroll('Chat');
                this.$router.push({
                    params: {
                        name: this.$route.name,
                        ...this.$route.params,
                        scrollTo: `#chat-item-${userId}`
                    },
                    hash: '#chat'
                }, () => {
                    this.messageToComplete(userId);
                })
            },
            async openRoom(roomId) {
                const allRooms = this.$store.getters['chat/allRooms'];
                const room = allRooms.find(item => item.id == roomId);

                if (room) {
                    resetScroll('Chat');
                    this.selectRoom(room);
                }
            },
            resizeHandler() {
                if (detectMob()) {
                    if (!this.showCloseBtn) {
                        EventBus.$emit('modalClosed');
                    }
                }
                else {
                    EventBus.$emit('modalClosed');
                }
            }
        },
        destroyed() {
            clearInterval(this.interval);
            EventBus.$off('messageTo', this.messageTo);
            EventBus.$off('openChatRoom', this.openRoom);
            window.addEventListener('resize', this.resizeHandler);
        },
        mounted() {
            this.$store.commit('chat/setMode', this.mode);
            this.$store.dispatch('chat/setClient', this.client);
            this.init();
            EventBus.$on('messageTo', this.messageTo);
            EventBus.$on('openChatRoom', this.openRoom);
            window.addEventListener('resize', this.resizeHandler);
        }
    });
</script>

<style lang="scss">
    @import "../style/style";
</style>
